import React, { useMemo } from "react";
import { Box, FormLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import enLocale from "dayjs/locale/en-au";
import SelectTimePicker from "./SelectTimePicker";

enLocale.formats = {
  ...enLocale.formats,
  L: "",
};

const BasicDateTimePicker = ({ name, label, value, onChange, disabled }) => {
  const selectedDate = useMemo(() => {
    return dayjs(value).isValid() ? dayjs(value) : dayjs();
  }, [value]);

  const selectedHour = selectedDate.hour();
  const selectedMinute = Math.floor(selectedDate.minute() / 5) * 5;

  const emitChange = (updatedDate) => {
    if (onChange) {
      onChange({
        target: {
          name,
          value: updatedDate.toISOString(),
        },
      });
    }
  };

  const handleDateChange = (newDate) => {
    if (!newDate) return;
    const updated = newDate.hour(selectedHour).minute(selectedMinute);
    emitChange(updated);
  };

  const handleHourChange = (event) => {
    const hour = Number(event.target.value);
    const updated = selectedDate.hour(hour).minute(selectedMinute);
    emitChange(updated);
  };

  const handleMinuteChange = (event) => {
    const minute = Number(event.target.value);
    const updated = selectedDate.hour(selectedHour).minute(minute);
    emitChange(updated);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"en-au"}>
      <Box className={`mui-field`} sx={{ display: "block !important" }}>
        {label && <FormLabel sx={{ mb: 1 }}>{label}</FormLabel>}
        <Box sx={{ display: "flex", gap: 2 }}>
          <DatePicker
            format="DD/MM/YYYY"
            value={selectedDate}
            onChange={handleDateChange}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard",
              },
            }}
            disabled={disabled}
          />

          <SelectTimePicker
            hour={selectedHour}
            minute={selectedMinute}
            onHourChange={handleHourChange}
            onMinuteChange={handleMinuteChange}
            disabled={disabled}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default BasicDateTimePicker;
